import React, { useState } from 'react';
import { bonuses, type Bonus } from '../data/bonuses';
import { BookCover } from './BookCover';
function BonusCover({
  bonus
}: {
  bonus: Bonus;
}) {
  const [failed, setFailed] = useState(false);
  if (bonus.cover && !failed) {
    return <div className="aspect-[5/4] overflow-hidden border-b border-ink-line bg-ink-deep" data-id="element-23" data-mp="asz5um8x2q65">
        <img src={bonus.cover} alt={`${bonus.title} cover`} loading="lazy" referrerPolicy="no-referrer" onError={() => setFailed(true)} className="h-full w-full object-cover object-center" data-id="element-24" data-mp="fsbsb5vvlv87" />
      </div>;
  }
  return <div className="flex h-[240px] items-center justify-center border-b border-ink-line bg-gradient-to-b from-ink-mid to-ink-deep sm:h-[280px]" data-id="element-25" data-mp="3o36aqjjht8id">
      <BookCover kicker={`Bonus ${bonus.number}`} title={bonus.short} accent={bonus.accent} className="h-[80%] w-auto -rotate-2" data-id="element-26" data-mp="1mai2twvwlww9" />
    </div>;
}
export function Bonuses() {
  return <section aria-labelledby="bonuses-heading" className="w-full bg-ink text-white" data-id="element-27" data-mp="1r6yz5ed9bhkf">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-28" data-mp="3icbtvu6x5tnd">
        <div className="text-center" data-id="element-29" data-mp="3dek3x5pu4hlt">
          <p className="text-[11px] font-semibold uppercase tracking-[1.6px] text-amber" data-id="element-30" data-mp="3ddis2z0zvr31">Also included at no extra cost</p>
          <h2 id="bonuses-heading" className="mt-3 font-display text-3xl font-extrabold text-white sm:text-5xl" data-id="element-31" data-mp="3n5esigqjztaf">
            Five instant-use <span className="italic text-amber" data-id="element-32" data-mp="2zglqc2jc8p7d">bonuses</span>
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-white/75" data-id="element-33" data-mp="2uh0rds464gun">
            The volumes give you the classes. These five get you using them
            faster — where to start, what to do when something happens in the air,
            where to place a new student, what to tell beginners and what music
            to play.
          </p>
        </div>

        <div className="mt-9 grid gap-4 sm:grid-cols-2" data-id="element-34" data-mp="ns49s7l5i48r">
          {bonuses.map((bonus, i) => <article key={bonus.number} className={`flex flex-col overflow-hidden rounded-2xl border border-ink-line bg-ink-card ${i === bonuses.length - 1 ? 'sm:col-span-2 sm:mx-auto sm:w-[calc(50%-8px)]' : ''}`} data-id="element-35" data-mp="it136ipivpyo" data-mpi={i}>
              <BonusCover bonus={bonus} data-id="element-36" data-mp="3lke2zvve2z21" />
              <div className="px-5 pb-6 pt-4" data-id="element-37" data-mp="3qifmghwq90e1">
                <div className="flex flex-wrap items-center gap-2" data-id="element-38" data-mp="3qi5xmxnf4z9x">
                  <span className="text-[11px] font-semibold uppercase tracking-widest text-white/60" data-id="element-39" data-mp="2tt823d7ugxbp">Bonus {bonus.number}</span>
                  <span className="rounded-full bg-teal px-2.5 py-1 text-[10px] font-bold uppercase tracking-wider text-white" data-id="element-40" data-mp="2xujqjfezfcib">Free today</span>
                </div>
                <h3 className="mt-2.5 font-display text-lg font-bold leading-tight tracking-tight text-white sm:text-xl" data-id="element-41" data-mp="37k3bqrq63igc">{bonus.title}</h3>
                <p className="mt-2 text-sm text-white/70" data-id="element-42" data-mp="2a45yvq0b7fo9">{bonus.body}</p>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}